import logo from './logo.svg';
import './App.css';
import { CountdownMain } from './components/countdown-main';

function App() {
  return (
    <CountdownMain />
  );
}

export default App;
